import { render, staticRenderFns } from "./WizardWrapper.vue?vue&type=template&id=428211a2&"
import script from "./WizardWrapper.vue?vue&type=script&lang=js&"
export * from "./WizardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./WizardWrapper.vue?vue&type=style&index=0&id=428211a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports